__turbopack_context__.v({
  "editor": "Layout-module__hDtaKq__editor",
  "editorWrapper": "Layout-module__hDtaKq__editorWrapper",
  "menu": "Layout-module__hDtaKq__menu",
});
